import { Link } from "@tanstack/react-router";
import { ArrowSquareOut } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { ConfigForm } from "@/components/admin/subscriptions/ConfigForm";
import { AdminSettingsSectionShell } from "../AdminSettingsSectionShell";

export function BillingSection() {
  return (
    <AdminSettingsSectionShell
      title="Naplata"
      description="Samo konfiguracija pretplate je ovdje. Lista terapeuta, pending uplate i ledger ostaju na stranici Pretplate."
      actions={
        <Button asChild variant="outline" size="sm">
          <Link to="/dashboard/admin/subscriptions">
            <ArrowSquareOut className="size-4" />
            Otvori ledger
          </Link>
        </Button>
      }
    >
      <ConfigForm />
    </AdminSettingsSectionShell>
  );
}
